import React, { useEffect } from 'react';
import withRouter from '../../components/withRouter';
import { useProfile } from '../../hooks/UserHooks';
import './integration.css'; // novo arquivo para customizações

// Importe os logos das integrações (adicione os arquivos na pasta public ou assets conforme necessário)
import googleAdManagerLogo from '../../assets/integrations/google-ad-manager.png';
import googleAnalyticsLogo from '../../assets/integrations/google-analytics.png';
import metaAdsLogo from '../../assets/integrations/meta.png';
import kwaiLogo from '../../assets/integrations/kwai.png';
import tiktokLogo from '../../assets/integrations/tiktok.png';

const integrations = [
    {
        name: 'Google Ad Manager',
        logo: googleAdManagerLogo,
        available: false,
    },
    {
        name: 'Google Analytics',
        logo: googleAnalyticsLogo,
        available: false,
    },
    {
        name: 'Meta Ads',
        logo: metaAdsLogo,
        available: false,
    },
    {
        name: 'Kwai Business',
        logo: kwaiLogo,
        available: false,
    },
    {
        name: 'TikTok Business',
        logo: tiktokLogo,
        available: false,
    },
];

const Index = (props: any) => {
    const { userProfile } = useProfile();

    useEffect(() => {
        document.title = 'Integrações | Ad Pulse';
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container">
                    <h2 className="mb-4">Integrações</h2>
                    <div className="row">
                        {integrations.map((integration, idx) => (
                            <div className="col-md-4 mb-4" key={integration.name}>
                                <div className={`card integration-card text-center ${!integration.available ? 'integration-soon' : ''}`}>
                                    <div className="card-body">
                                        <img
                                            src={integration.logo}
                                            alt={integration.name}
                                            className="integration-logo mb-3"
                                        />
                                        <h5 className="card-title">{integration.name}</h5>
                                        {!integration.available && (
                                            <span className="badge bg-secondary">Em breve</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default withRouter(Index);